<template>
  <Header />
  <div style="background-color: #f7f7f7; padding-bottom: 10px;">
    <div class="news-content">
      <div class="nav-link">
        当前位置：
        <router-link to="/">首页</router-link>
        &gt; 注册测绘师执业系统
      </div>
      <div class="main-content">
        <img
          class="product-img"
          src="/img/cehuishi_detail.jpg"
          alt="注册测绘师执业系统"
        />
      </div>
    </div>
  </div>
  <Footer />
</template>

<script setup>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
</script>

<style lang="scss" scoped>
.news-content {
  max-width: 1164px;
  width: 100%;
  border: 1px solid #eaeaea;
  margin: 0 auto;
  margin-top: 10px;
  background-color: #fff;

  .nav-link {
    height: 40px;
    line-height: 40px;
    padding-left: 12px;
    border-bottom: 1px solid #f8f8f8;

    a {
      color: #2a6fdb;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .main-content {
    padding: 16px 12px 24px;
  }

  .product-img {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
  }
}
</style>